export default "__VITE_ASSET__D044Pzay__"